// extracted by mini-css-extract-plugin
export default {"header":"_37e9o","wrapper":"N5B84","headerWrapper":"_2rf9I","headerLink":"_3oYd-","direct":"_3LyO9","channelsWrapper":"_26Ct_","channelSectionTitle":"_3Yy1R"};